import { render, staticRenderFns } from "./MapDialog.vue?vue&type=template&id=636b2345&scoped=true"
import script from "./MapDialog.vue?vue&type=script&lang=js"
export * from "./MapDialog.vue?vue&type=script&lang=js"
import style0 from "./MapDialog.vue?vue&type=style&index=0&id=636b2345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b2345",
  null
  
)

export default component.exports